module.exports = __webpack_public_path__ + "static/img/home_style_two.21f5854.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home_style_two.png
// module id = HovA
// module chunks = 1